import { SET_REDIRECT_URL, SET_USER, CLEAR_USER } from "./mutations-type"

export default {
    namespaced: true,
    actions: {
        setRedirectUrl({ commit }, url) {
            commit(SET_REDIRECT_URL, url)
        },
        setUser({ commit }, user){
            commit(SET_USER, user)
        }
    },
    mutations: {
        [SET_REDIRECT_URL]: (state, url) => {
            state.redirectUrl = url
        },
        [SET_USER]: (state, user) => {
            state.user = user
        },
        [CLEAR_USER]: (state) => {
            state.user = null
        },
    },
    state: {
        redirectUrl: '/home',   // 登录成功后的调整地址
        user: JSON.parse(localStorage.getItem('user')),   // 登录成功后的用户信息
    },
    getters: {}
}